import React, { useEffect } from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Segments/ScrolToTop';
import Loader from "./components/Segments/Loader";
import LazyImageManager from './components/Parts/LazyImageManager';

const EXTERNAL_SCRIPTS = [
  'https://cdn.botpress.cloud/webchat/v2.2/inject.js',
  'https://files.bpcontent.cloud/2024/11/01/17/20241101173906-CIX1T9L8.js'
];

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return undefined;
    }

    const scriptElements = [];
    let idleHandle = null;
    let timeoutHandle = null;
    let loaded = false;

    const loadExternalScripts = () => {
      if (loaded) {
        return;
      }

      loaded = true;
      EXTERNAL_SCRIPTS.forEach((src) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
        scriptElements.push(script);
      });
    };

    const scheduleLoad = () => {
      if (typeof window.requestIdleCallback === 'function') {
        idleHandle = window.requestIdleCallback(loadExternalScripts, { timeout: 4500 });
        return;
      }

      timeoutHandle = window.setTimeout(loadExternalScripts, 2500);
    };

    const handleInteraction = () => {
      loadExternalScripts();
    };

    window.addEventListener('pointerdown', handleInteraction, { once: true, passive: true });
    window.addEventListener('keydown', handleInteraction, { once: true });
    scheduleLoad();

    return () => {
      if (idleHandle && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleHandle);
      }

      if (timeoutHandle) {
        window.clearTimeout(timeoutHandle);
      }

      window.removeEventListener('pointerdown', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);

      scriptElements.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <div className="App">
      <LazyImageManager />
      <Components />
      <ScrolToTop/>
      <Loader/>
    </div>
  );
}

export default App;
